import React from 'react';
import classNames from 'classnames';

import { PaddingContainer, WidthContainer } from '@components';
import InternalIntegrationIcon from '@images/icons/internal-integration.svg';
import ExternalIntegrationIcon from '@images/icons/external-integration.svg';

import * as styles from './SystemIntegrations.module.scss';

export const SystemIntergrations: React.FC = () => {
	return (
		<PaddingContainer className="gray-bg">
			<WidthContainer>
				<h2 className="font-size-medium-title">System integrations</h2>
				<div
					className={classNames(
						styles.container,
						'mt-5 d-flex flex-column flex-lg-row font-size-sm'
					)}
				>
					<div className={styles.item}>
						<img
							className="mb-2"
							src={ExternalIntegrationIcon}
							alt="External integration"
						/>
						<p className="font-600 font-size-md mb-1">External integration</p>
						<p className="line-height-26">
							Integration between an external device using a hub based on some
							RapberryPi, Arduino or another microcontroller to the network. We
							can connect an intelligent sensor (such as a water filter,
							proximity, humidity sensor, etc.), to the internet, indicators or
							build testing tools that will connect via digital interfaces and
							perform tests.
						</p>
					</div>
					<div className={styles.item}>
						<img
							className="mb-2"
							src={InternalIntegrationIcon}
							alt="Internal integration"
						/>
						<p className="font-600 font-size-md mb-1">Internal integration</p>
						<p className="line-height-26">
							If you have different systems, or if you have a provider, or if
							you produce something, e.g. for intelligent waste collection, then
							the system integrates internally and you need interfaces. We can
							create such interfaces and connect them or combine them with
							existing ones. Sensors, devices, local devices, and global
							integration to most data acquisition systems. Integration for
							testing. Devices that do not have an output to the Internet.
						</p>
					</div>
				</div>
			</WidthContainer>
		</PaddingContainer>
	);
};
